import { useResponsive } from 'hooks/useResponsive';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';

export const useJaguar = () => {
  const { isDesktop } = useResponsive();
  const isLoginEnabledJourney = useIsLoginEnabledJourney();
  const isJaguar = !isLoginEnabledJourney;

  const columnRatio = !isLoginEnabledJourney ? '2' : '1';
  return {
    isJaguar,
    isDesktop,
    columnRatio
  };
};
